<template>
  <FieldHistoryButton
    v-if="itemId"
    class="ms-2"
    :model-name="ctx.modelName"
    :item-id="itemId"
    :field-path="field.key"
    :field="field"
  />
</template>

<script>
import FieldHistoryButton from "./FieldHistoryButton.vue";

/**
 * Botón de historial para el label que dibujan los campos de model-definition-core en la
 * ficha. El registro lo provee ViewContent (`fieldHistoryContext`); fuera de una ficha, o en
 * filas de grupos, no hay contexto y no se dibuja nada.
 */
export default {
  name: "FieldHistoryLabelButton",
  components: { FieldHistoryButton },
  inject: {
    fieldHistoryContext: { default: null },
  },
  props: {
    field: { type: Object, required: true },
    mode: { type: String, default: "view" },
  },
  computed: {
    ctx() {
      return this.fieldHistoryContext || {};
    },
    itemId() {
      if (this.mode !== "view" || !this.field || !this.field.showHistory) return null;
      return this.ctx.itemId && this.ctx.modelName ? this.ctx.itemId : null;
    },
  },
};
</script>
